<template>
  <button @click="toggleMenu" class="burger-menu-icon" aria-label="Open menu">
    <span></span>
    <span></span>
    <span></span>
  </button>
</template>

<script setup>
const emit = defineEmits(['toggle']);

function toggleMenu() {
  emit('toggle');
}
</script>

<style scoped>
.burger-menu-icon {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  width: 40px;
  height: 40px;
  padding: 13px;
  background: transparent;
  border: none;
  cursor: pointer;
  box-sizing: border-box;
}

.burger-menu-icon span {
  width: 100%;
  height: 2px;
  background: #0470E4;
  border-radius: 10px;
}
</style>